import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policies',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policies.component.html',
  styleUrl: './privacy-policies.component.scss'
})
export class PrivacyPoliciesComponent {
  return() {
    window.history.back();
  }
}
